<div class="customBar">
  <div class="header">

    <div *ngIf="this.proyectoService.getProyectoActual() != null &&
                (situation == 'locations' || situation == 'devices' || situation == 'indicators' || situation == 'floorplans' || situation == 'zones' ||
                situation == 'alerts' || situation == 'reglas' || situation == 'fade' ||
                situation == 'limits' || situation == 'ota' || situation == 'parameters')" (click)="toLocations(true)"
         class="menuLocation centerVert">

      <div style="display: inline; margin: 0 20px" class="">
        <span style="" class="centerVert material-icons-outlined textXXM">place</span>
      </div>

      <div style="display: inline; margin-right: 25px;">
        <h3 class="locationText centerVert textM">{{this.proyectoService.getProyectoActual().nombre}}</h3>
      </div>

    </div>

    <img (click)="toHome()" class="logo" src="../../../assets/img/Logo_ATENEA_Azul.png" alt="Atenea logo">
    <div class="centerVert textM welcome">
      <span class="wSpan">{{this.localiser.get("header.welcome")}} {{this.user.getName()}}</span>
      <span (click)="toProfile()" class="material-icons-outlined customHeaderIcon textL">manage_accounts</span>
    </div>
  </div>
  <div class="menu">

    <div class="container menuContainer">
      <div class="row projectList">

        <!-- ATENEO MENU -->
        <div *ngIf="user.getPermiso() == Roles.Ateneo" class="scrollable">

          <!-- HOME-->
          <div (click)="toHome()" class="row userLogo">
            <div class="col-4 faceIcon">
              <span class="material-icons-outlined customIcon textL">face</span>
            </div>

            <div class="col-8">
              <h1 class="centerVert text-left textL">Ateneo</h1>
            </div>
          </div>

          <div class="menuButtons">
            <!-- LOCATIONS -->
            <div (click)="toLocations(false)" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'locations'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">place</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.locations")}}</h3>
              </div>
            </div>

            <!-- FLOORPLANS -->
            <div  (click)="toFloorplans()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'floorplans'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">layers</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.floorplans")}}</h3>
              </div>
            </div>

            <!-- DEVICES -->
            <div (click)="toDevices()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'devices'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">sensors</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.devices")}}</h3>
              </div>
            </div>

            <!--add here a line separator-->

            <div class="row menuRow menu-separator-line"></div>

            <!-- ZONES -->
            <div  (click)="toAteneoZones()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'zones'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">smart_button</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.zones")}}</h3>
              </div>
            </div>

            <div (click)="toReglas()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reglas'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">schedule</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.rules")}}</h3>
              </div>
            </div>

            <!-- FADE -->
            <div (click)="toFade()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'fade'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">settings_suggest</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.fade")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- INDICATORS -->
            <div (click)="toIndicators()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'indicators'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">equalizer</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.indicators")}}</h3>
              </div>
            </div>

            <!-- ALERTS -->
            <div (click)="toAlerts()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'alerts'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">warning_amber</span>
              </div>


              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.alerts")}}</h3>
              </div>
            </div>

            <!-- REPORTS -->
            <div (click)="toReports()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reports'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">analytics</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.reports")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- AIRFAL -->
            <div (click)="toAirfal()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'airfal'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">info</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.airfal")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

          </div>

        </div>

        <!-- CONFIGURATOR MENU -->
        <div *ngIf="user.getPermiso() == Roles.Configuracion" class="scrollable">

          <!-- HOME-->
          <div (click)="toHome()" class="row userLogo">
            <div class="col-4 faceIcon">
              <span class="material-icons-outlined customIcon textL">settings</span>
            </div>

            <div class="col-8">
              <h1 class="centerVert text-left textM">{{this.localiser.get("menu.configurator")}}</h1>
            </div>
          </div>

          <div class="menuButtons">
            <!-- LOCATIONS -->
            <div (click)="toLocations(false)" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'locations'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">place</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.locations")}}</h3>
              </div>
            </div>

            <!-- FLOORPLANS -->
            <div  (click)="toFloorplans()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'floorplans'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">layers</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.floorplans")}}</h3>
              </div>
            </div>

            <!-- DEVICES -->
            <div (click)="toDevices()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'devices'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">sensors</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.devices")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- ZONES -->
            <div  (click)="toAteneoZones()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'zones'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">smart_button</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.zones")}}</h3>
              </div>
            </div>

            <div (click)="toReglas()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reglas'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">schedule</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.rules")}}</h3>
              </div>
            </div>

            <!-- FADE -->
            <div (click)="toFade()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'fade'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">settings_suggest</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.fade")}}</h3>
              </div>
            </div>

            <!-- THRESHOLDS -->
            <div (click)="toLimits()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'limits'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">sort</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.limits")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- INDICATORS -->
            <div (click)="toIndicators()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'indicators'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">equalizer</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.indicators")}}</h3>
              </div>
            </div>

            <!-- ALERTS -->
            <div (click)="toAlerts()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'alerts'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">warning_amber</span>
              </div>


              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.alerts")}}</h3>
              </div>
            </div>

            <!-- REPORTS -->
            <div (click)="toReports()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reports'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">analytics</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.reports")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- AUTOTEST -->
            <div (click)="toAutotest()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'autotest'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">published_with_changes</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.autotest")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- AIRFAL -->
            <div (click)="toAirfal()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'airfal'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">info</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.airfal")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

          </div>
        </div>

        <!-- ADMINISTRATOR MENU -->
        <div *ngIf="user.getPermiso() == Roles.Administrador" class="scrollable">

          <!-- HOME-->
          <div (click)="toHome()" class="row userLogo">
            <div class="col-4 faceIcon">
              <span class="material-icons-outlined customIcon textL">settings</span>
            </div>

            <div class="col-8">
              <h1 class="centerVert text-left textL">{{this.localiser.get("menu.admin")}}</h1>
            </div>
          </div>

          <div class="menuButtons">
            <!-- LOCATIONS -->
            <div (click)="toLocations(false)" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'locations'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">place</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.locations")}}</h3>
              </div>
            </div>

            <!-- FLOORPLANS -->
            <div  (click)="toFloorplans()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'floorplans'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">layers</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.floorplans")}}</h3>
              </div>
            </div>

            <!-- DEVICES -->
            <div (click)="toDevices()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'devices'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">sensors</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.devices")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- ZONES -->
            <div  (click)="toAteneoZones()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'zones'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">smart_button</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.zones")}}</h3>
              </div>
            </div>

            <div (click)="toReglas()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reglas'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">schedule</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.rules")}}</h3>
              </div>
            </div>

            <!-- FADE -->
            <div (click)="toFade()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'fade'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">settings_suggest</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.fade")}}</h3>
              </div>
            </div>

            <!-- THRESHOLDS -->
            <div (click)="toLimits()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'limits'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">sort</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.limits")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- INDICATORS -->
            <div (click)="toIndicators()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'indicators'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">equalizer</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.indicators")}}</h3>
              </div>
            </div>

            <!-- ALERTS -->
            <div (click)="toAlerts()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'alerts'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">warning_amber</span>
              </div>


              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.alerts")}}</h3>
              </div>
            </div>

            <!-- REPORTS -->
            <div (click)="toReports()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'reports'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">analytics</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.reports")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- AUTOTEST -->
            <div (click)="toAutotest()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'autotest'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">published_with_changes</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.autotest")}}</h3>
              </div>
            </div>

            <!-- PARAMETERS -->
            <div (click)="toParameters()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'parameters'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">tune</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.parameters")}}</h3>
              </div>
            </div>

            <!-- OTA -->
            <div (click)="toOta()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'ota'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">contactless</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">OTA</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

            <!-- USERS -->
            <div (click)="toUsers()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'users'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">people</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.users")}}</h3>
              </div>
            </div>

            <!-- AIRFAL -->
            <div (click)="toAirfal()" class="row menuRow" [ngClass]="{'selectedRow': this.situation == 'airfal'}">
              <div class="col-3 text-right">
                <span class="material-icons-outlined customRowIcon textXM">info</span>
              </div>

              <div class="col-9">
                <h3 class="centerVert text-left textM">{{this.localiser.get("menu.airfal")}}</h3>
              </div>
            </div>

            <div class="row menuRow menu-separator-line"></div>

          </div>
        </div>
      </div>
      <div class="container downButtons">

        <div class="row menuButtonsTop">

          <div class="col-5" style="padding-right: 0; margin: auto">
            <button type="submit" (click)="logOut()" class="logOut btn textS">{{this.localiser.get("menu.logOut")}}</button>
          </div>

          <div class="col" style="margin: auto">
            <mat-select class="language textS" (ngModelChange)="changeLanguage($event)"
                        [(ngModel)]="this.localiser.languageName">
              <mat-option value="Español">Español</mat-option>
              <mat-option value="English">English</mat-option>
            </mat-select>
          </div>

        </div>
        <div class="row menuButtonsBottom">
          <div class="col">
            <div class="row contact" (click)="toAirfal()">

              <div style="color: white" class="col-9; marginAuto">
                <h6 class="text-center textXS marginAuto">{{this.localiser.get("menu.contactTeam")}}</h6>
              </div>

              <div class="col-3">
                <span class="material-icons-outlined customIcon textXM">support_agent</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

